export const currencySymbols: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: 'A$',
  NZD: 'NZ$',
  CAD: 'C$',
  BRL: 'R$',
  SEK: 'kr',
  CHF: 'CHF',
  DKK: 'kr',
  NOK: 'kr',
  PLN: 'zł',
  ZAR: 'R',
  HKD: 'HK$',
  CZK: 'Kč',
  TWD: 'NT$',
  KRW: '₩',
  RUB: '₽',
  ARS: '$',
  COP: '$',
  MXN: '$',
  PEN: 'S/',
  MYR: 'RM',
  SGD: 'S$',
  CNY: '¥',
  'CNY(on)': '¥',
  'CNH(off)': '¥',
  INR: '₹',
  'INR(on)': '₹',
  'INR(off)': '₹',
  IDR: 'Rp',
  'IDR(on)': 'Rp',
  'IDR(off)': 'Rp',
  CLP: '$',
  CLF: 'UF',
  ILS: '₪',
  PHP: '₱',
  HRK: 'kn',
  UAH: '₴',
  ISK: 'kr',
  TRY: '₺',
  THB: '฿',
  SAR: '﷼',
  KZT: '₸',
  CRC: '₡',
  KYD: '$',
  VND: '₫',
};